import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star, Trash2, CheckCircle2, XCircle } from "lucide-react";
import { listReviewsAdmin, moderateReview, deleteReviewAdmin } from "../api";
import { PageHeader } from "./Dashboard";
import RefreshButton from "../components/RefreshButton";

export default function AdminReviews() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");

  const reload = () => {
    setLoading(true);
    listReviewsAdmin(filter).then(setItems).finally(() => setLoading(false));
  };
  useEffect(reload, [filter]); // eslint-disable-line

  const moderate = async (id, approved) => {
    await moderateReview(id, approved);
    reload();
    toast.success(approved ? "Approved" : "Hidden");
  };

  const del = async (id) => {
    if (!window.confirm("Delete this review permanently?")) return;
    await deleteReviewAdmin(id);
    reload();
    toast.success("Removed");
  };

  return (
    <div data-testid="admin-reviews">
      <PageHeader eyebrow="Community" title="Reviews" sub={`${items.length} entries · live moderation`} />
      <div className="p-10">
        <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
          <RefreshButton onClick={reload} loading={loading} testid="admin-reviews-refresh" />
          <select value={filter} onChange={(e) => setFilter(e.target.value)} className="bg-[#0d0d0e] border border-[#2a2a2d] text-[#e9e6db] px-3 py-2.5 text-[13px]" data-testid="admin-reviews-filter">
            <option value="">All</option>
            <option value="approved">Approved</option>
            <option value="pending">Hidden</option>
          </select>
        </div>

        <div className="bg-[#161617] border border-[#2a2a2d]">
          {loading ? (
            <p className="p-8 text-center text-[#8c8a7e] text-sm">Loading…</p>
          ) : items.length === 0 ? (
            <p className="p-8 text-center text-[#8c8a7e] text-sm">No reviews yet.</p>
          ) : (
            items.map((r) => (
              <div key={r.id} className="p-6 border-b border-[#2a2a2d]" data-testid={`review-${r.id}`}>
                <div className="flex items-start justify-between gap-4 flex-wrap">
                  <div>
                    <div className="flex items-center gap-2">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <Star key={i} size={13} className={i < r.rating ? "fill-[#c3ba9e] text-[#c3ba9e]" : "text-[#5e5d54]"} />
                      ))}
                      {r.verified_purchase && <span className="text-[10px] tracking-[0.22em] uppercase text-[#8ccf9a]">Verified</span>}
                      {!r.approved && <span className="text-[10px] tracking-[0.22em] uppercase text-[#c79a3a]">Hidden</span>}
                    </div>
                    {r.title && <p className="font-serif-display text-xl text-[#e9e6db] mt-2">{r.title}</p>}
                    <p className="text-[#c3ba9e]/85 text-sm mt-1.5 leading-relaxed">{r.body}</p>
                    <p className="text-[11px] text-[#8c8a7e] mt-2">
                      {r.author_name} · {r.author_email} · {r.product_slug} · {new Date(r.created_at).toLocaleDateString("en-IN")}
                    </p>
                  </div>
                  <div className="flex items-center gap-2 shrink-0">
                    {r.approved ? (
                      <button onClick={() => moderate(r.id, false)} className="text-[11px] tracking-[0.22em] uppercase border border-[#2a2a2d] text-[#c79a3a] px-3 py-2 flex items-center gap-1.5"><XCircle size={12} /> Hide</button>
                    ) : (
                      <button onClick={() => moderate(r.id, true)} className="text-[11px] tracking-[0.22em] uppercase border border-[#2a2a2d] text-[#8ccf9a] px-3 py-2 flex items-center gap-1.5"><CheckCircle2 size={12} /> Approve</button>
                    )}
                    <button onClick={() => del(r.id)} className="text-[11px] tracking-[0.22em] uppercase border border-[#2a2a2d] text-[#c97070] px-3 py-2"><Trash2 size={12} /></button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
